import { EncoderDecoder } from '@iotize/common/converter/api';
import { TLV } from '@iotize/common/tlv';

export class TLVConverter implements EncoderDecoder<TLV.TlvNode, Uint8Array> {
  serializer: TLV.Serializer;
  parser: TLV.Parser;

  constructor() {
    this.serializer = new TLV.Serializer();
    this.parser = new TLV.Parser();
  }

  encode(data: TLV.TlvNode): Uint8Array {
    return this.serializer.serialize(data);
  }

  decode(data: Uint8Array): TLV.TlvNode {
    let tlvTree = this.parser.parse(data);
    return tlvTree;
  }
}
